<template>
  <v-card
    ref="viewSection"
    class="mx-auto"
    color="transparent"
    elevation="0"
  >
    <FacetsToolbar
      :config="config"
      :loading="loading"
      :focus-mode-toolbar-top="focusModeToolbarTop"
      :has-default-sort="false"
      class="d-block"
      :class="{ 'd-lg-none': !appliedFilters.length }"
    />

    <section
      class="my-8 my-lg-16 px-4 d-flex pa-0 col-12"
      :class="{ 'mt-12' : focusMode }"
      style="position: relative;"
    >
      <Facets
        v-if="$vuetify.breakpoint.lgAndUp"
        :filters-config="getFiltersConfig"
        :hide-sidebar.sync="hideSidebar"
        :hide-count="true"
      />
      <section
        v-if="$vuetify.breakpoint.lgAndUp"
        class="d-flex justify-center px-0"
        :class="{'ml-8' : !hideSidebar}"
      >
        <v-btn
          absolute
          fab
          top
          dark
          x-small
          color="primary"
          style="z-index: 1;"
          @click="changeSideBar()"
        >
          <v-icon dark>
            {{ hideSidebar ? "mdi-forwardburger" : "mdi-backburger" }}
          </v-icon>
        </v-btn>
        <v-divider
          class="fill-height"
          inset
          vertical
        />
      </section>

      <div
        class="content flex-wrap col pa-0 overflow-x-auto"
        :class="$vuetify.breakpoint.lgAndUp ? 'ml-6' : 'ml-0'"
      >
        <DataIterator
          :table-config="config"
          :actions-config="config"
          :list="getTableItems"
          template="ListItemForCandidates"
          :items-per-page="(config.views?.list.itemsPerPage || 1)"
        >
          <template #top>
            <ListToolbar
              :total="getTotal"
              :actions="config.views.list.actions.top"
              create-permission="CREATE_PROSPECT"
              @action-click="handleAction"
            />
          </template>
        </DataIterator>

        <v-pagination v-model="page" :disabled="!canPerformAction('VIEW_PROSPECT') || pageCount <= 1" :length="pageCount" total-visible="5" class="py-6" />
      </div>
    </section>
  </v-card>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex';

import FacetsToolbar from '@/components/dynamic/list/components/FacetsToolbar.vue';
import Facets from '@/components/Facets.vue';
import DataIterator from '@/components/table/DataIterator.vue';
import ListToolbar from '@/components/dynamic/list/components/ListToolbar.vue';

export default {
  name: 'GenericListing',
  components: {
    FacetsToolbar,
    Facets,
    DataIterator,
    ListToolbar
  },
  props: {
    config: {
      type: Object,
      default: () => ({})
    },
    contentTypeLabel: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      hideSidebar: false,
      loading: {
        skeleton: false,
        form: false
      }
    };
  },
  computed: {
    ...mapState(['focusMode', 'appliedFilters', 'sort', 'offer', 'activeWorkspace']),
    ...mapGetters(['getTableItems', 'getFiltersConfig', 'getTotal', 'getSortValueByKey', 'canPerformAction']),
    page: {
      get () {
        return this.$store.state.page;
      },
      set (value) {
        this.setPage(Number(value));
      }
    },
    pageCount () {
      return Math.ceil(this.getTotal / (this.config.views?.list.itemsPerPage || 1));
    },
    focusModeToolbarTop () {
      if (this.$vuetify.breakpoint.xsOnly) {
        return '64px';
      }
      return this.focusMode ? '24px' : '88px';
    }
  },
  watch: {
    getTableItems (newVal) {
      if (newVal.length && this.pageCount !== 0) {
        this.scrollToField('viewSection');
      }
    }
  },
  updated () {
    this.setItemsByPage(this.config.views?.list.itemsPerPage || 1);
  },
  methods: {
    ...mapActions(['setPage', 'searchData', 'clearFiltersAndSearch', 'removeFilterAndSearch', 'setSort']),
    ...mapMutations(['setItemsByPage']),
    findFilterConfigByComponent (attribute) {
      return this.config.filters.find(facet => facet.attribute === attribute);
    },
    async getData () {
      this.searchData();
    },
    changeSideBar () {
      this.hideSidebar = !this.hideSidebar;
    },
    scrollToField (field) {
      this.$vuetify.goTo(this.$refs[field], {
        duration: 500,
        offset: 64 + 16,
        easing: 'easeInOutCubic'
      });
    },
    handleAction (action) {
      switch (action.mode) {
        case 'creer': {
          this.$router.push({ name: 'add-candidate' });
          break;
        }
        case 'refresh': {
          this.searchData();
          break;
        }
        default: {
          console.log('Action Clicked', action);
        }
      }
    }
  }
};
</script>

<style scoped>
@container actions-container (max-width: 1060px) {
  :deep(.desktop-actions) {
    display: none;
  }

  :deep(.mobile-actions) {
    display: block;
  }
}
</style>
